import { ReportableError } from '@amazon/vinyl-util'

export class UnauthorizedError extends ReportableError {
    get [Symbol.toStringTag](): string {
        return 'UnauthorizedError'
    }
}
